import * as React from 'react'
import { designTokens } from '../../lib/design-tokens'

type IconProps = React.SVGProps<SVGSVGElement> & {
  color?: string
  strokeWidth?: number
}

export const UsersIcon = ({
  width = 20,
  height = 20,
  color = designTokens.colors.background.paymentScheduleActive,
  strokeWidth = Number.parseFloat(designTokens.borders.widths.mobileTabIcon),
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    focusable="false"
    aria-hidden="true"
    {...props}
  >
    <circle
      cx="2.83688"
      cy="2.83688"
      r="2.83688"
      transform="matrix(-1 0 0 1 13.0137 4.16699)"
      stroke={color}
      strokeWidth={strokeWidth}
    />
    <path
      d="M5.21289 14.0503C5.21289 13.4401 5.59648 12.8958 6.17111 12.6906C8.76185 11.7653 11.593 11.7653 14.1837 12.6906C14.7584 12.8958 15.142 13.4401 15.142 14.0503V14.9833C15.142 15.8255 14.3961 16.4724 13.5624 16.3533L13.2844 16.3136C11.2236 16.0191 9.1313 16.0191 7.07043 16.3136L6.79247 16.3533C5.95878 16.4724 5.21289 15.8255 5.21289 14.9833V14.0503Z"
      stroke={color}
      strokeWidth={strokeWidth}
    />
    <path
      d="M14.4331 9.91889C15.6642 9.91889 16.6621 8.92094 16.6621 7.68991C16.6621 6.45888 15.6642 5.46094 14.4331 5.46094"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M16.8752 15.0036L17.0936 15.0348C17.7486 15.1284 18.3347 14.6201 18.3347 13.9584V13.2254C18.3347 12.746 18.0333 12.3183 17.5818 12.157C17.1314 11.9962 16.6718 11.8709 16.207 11.7812"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M5.56882 9.91889C4.33779 9.91889 3.33984 8.92094 3.33984 7.68991C3.33984 6.45888 4.33779 5.46094 5.56882 5.46094"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M3.12676 15.0036L2.90836 15.0348C2.25332 15.1284 1.66726 14.6201 1.66726 13.9584V13.2254C1.66726 12.746 1.96865 12.3183 2.42015 12.157C2.87052 11.9962 3.33015 11.8709 3.79492 11.7812"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
  </svg>
)

UsersIcon.displayName = 'UsersIcon'
